<!--
  Search Console (GSC_INTEGRATION.md stage 1). Nothing at all renders for a workspace that has not
  connected it, or on another domain's Setup (§1a).
-->
<section class="gsc-connection card card--pad" *ngIf="visible && connection as c" aria-labelledby="gsc-connection-heading">
  <div class="gsc-connection-head">
    <h2 id="gsc-connection-heading">Search Console</h2>
    <span class="badge" [ngClass]="statusClass()">{{ statusLabel() }}</span>
  </div>

  <p class="gsc-connection-status">{{ c.statusLine }}</p>

  <dl class="gsc-connection-facts">
    <div class="gsc-connection-fact">
      <dt>Property</dt>
      <dd>{{ c.property }} <span class="gsc-connection-muted">· {{ c.credentialLabel }}</span></dd>
    </div>
    <div class="gsc-connection-fact">
      <dt>Last synced</dt>
      <dd>
        <ng-container *ngIf="c.lastSyncedAt; else never">{{ c.lastSyncedAt | date: 'EEE d MMM, HH:mm' }}</ng-container>
        <ng-template #never>Not yet</ng-template>
        <span class="gsc-connection-muted" *ngIf="c.dataThrough">· data through {{ c.dataThrough }}</span>
      </dd>
    </div>
    <div class="gsc-connection-fact">
      <dt>Scope</dt>
      <dd>{{ c.scopeLine }}</dd>
    </div>
    <div class="gsc-connection-fact">
      <dt>Comparison searches</dt>
      <dd>{{ c.serpQueryLine }}</dd>
    </div>
    <div class="gsc-connection-fact" *ngIf="c.pages as p">
      <dt>Crawled pages</dt>
      <dd>
        {{ p.gsc }} with a Search Console query · {{ p.lowData }} with little data<span *ngIf="p.newPage"> · {{ p.newPage }} new</span><span *ngIf="p.brandOnly"> · {{ p.brandOnly }} with brand searches only</span>
        <span class="gsc-connection-muted">· {{ p.unmatched }} Search Console pages we do not crawl</span>
      </dd>
    </div>
  </dl>

  <div class="gsc-connection-controls">
    <label class="field gsc-connection-brand">
      <span class="field__label">Brand terms</span>
      <input class="input" type="text" [(ngModel)]="draftBrandTerms" [disabled]="saving" placeholder="manyrequests, many requests" />
      <span class="field__hint">Searches containing these are never a page's main query. Spacing does not matter.</span>
    </label>
    <button type="button" class="btn btn--sm" (click)="saveBrandTerms()" [disabled]="saving || !brandTermsChanged()">
      {{ saving ? 'Saving…' : 'Save' }}
    </button>
    <button type="button" class="btn btn--sm btn--quiet" (click)="syncNow()" [disabled]="syncing">
      {{ syncing ? 'Syncing…' : 'Sync now' }}
    </button>
  </div>
</section>
